import { TableList, TableListProvider, Typography } from 'seagull';
import { getServicesTableDefs } from "../EditDraftsTable.utils";
import EditDraftServiceRow from "./EditDraftServiceRow";
import styles from "./EditDraftService.module.scss";
import EditPackageNameButton from "../serviceCells/EditPackageNameButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getServicesByBundle = draft => {
  const services = draft.services();
  const standaloneServices = services.length > 0 ? [{
    packageName: null,
    services,
    packageId: null
  }] : [];
  const bundledServices = draft.serviceBundles().map(bundle => ({
    packageName: bundle.name,
    packageId: bundle.id,
    services: bundle.services
  }));
  return [...standaloneServices, ...bundledServices];
};
export default function EditDraftServiceTable(_ref) {
  let {
    draft,
    onOpenModal
  } = _ref;
  const servicesTableDefs = getServicesTableDefs();
  const servicesByBundle = getServicesByBundle(draft);
  const isDisabled = draft.isScheduled();
  const disabledTooltip = isDisabled ? 'In order to edit a scheduled proposal, its scheduling must be canceled.' : undefined;
  return /*#__PURE__*/_jsx("div", {
    children: servicesByBundle.map((_ref2, bundleIndex) => {
      let {
        packageName,
        packageId,
        services
      } = _ref2;
      return /*#__PURE__*/_jsxs("div", {
        className: styles.bundleTable,
        children: [packageId && /*#__PURE__*/_jsxs("div", {
          className: styles.bundleHeader,
          "data-testid": "bundle-header-".concat(packageId),
          children: [/*#__PURE__*/_jsx(Typography, {
            "data-testid": "package-name-".concat(packageId),
            children: packageName
          }), /*#__PURE__*/_jsx(EditPackageNameButton, {
            packageName: packageName,
            draft: draft,
            packageId: packageId,
            onOpenModal: onOpenModal
          })]
        }), /*#__PURE__*/_jsxs(TableListProvider, {
          columnDefs: servicesTableDefs,
          hasActionColumn: true,
          children: [/*#__PURE__*/_jsx(TableList.Header, {
            items: servicesTableDefs
          }), services.length > 0 && services.map((service, index) => /*#__PURE__*/_jsx(EditDraftServiceRow, {
            service: service,
            packageId: packageId,
            index: index,
            draft: draft,
            onOpenModal: onOpenModal,
            isDisabled: isDisabled,
            disabledTooltip: disabledTooltip
          }, service.id)), services.length === 0 && packageId && /*#__PURE__*/_jsx("div", {
            className: styles.noServices,
            children: /*#__PURE__*/_jsx(Typography, {
              children: "No services in the package"
            })
          })]
        })]
      }, packageId || "standalone-".concat(bundleIndex));
    })
  });
}